function Team() {
  return (
    <div>
      <h1>Team</h1>
    </div>
  );
}

export default Team;
